import React from 'react'
import { connect } from 'react-redux'

import Songs from './Songs'


const SongsContainer = props => (
    <Songs
        id={props.id}
        name={props.name}
        className={props.className}
        songs={props.songs}
        selected={props.selected_video}
        markItems={props.markItems}
        tags={props.tags}
        turn={props.turn}
        cliptime={props.cliptime}
        tempo={props.tempo}
        songauthor_name={props.songauthor_name}
        player_name={props.player_name}
        album_name={props.album_name}
        genre_name={props.genre_name}
        year={props.year}
        filename={props.filename}
        mimetype={props.mimetype}
        variant={props.variant}
        ctime={props.ctime}
        audio={props.audio}
        trackPlaying={props.trackPlaying}
        isPlaying={props.isPlaying}
        isWatching={props.isWatching}
        play={props.play}
        pause={props.pause}
        stop={props.stop}
        rewind={props.rewind}
        isAdditionalMenuOpened={props.isAdditionalMenuOpened}
        isAdditionalSelected={props.isAdditionalSelected}
        leftMarker={props.leftMarker}
        showMore={props.showMore}
    />
)

const stateToProps = (state, props) => ({
    markItems: [...state.marks[state.marks.current].items],
    // selected: [...state.videolists_all.selected],
    selected: [...state.videolists_all.selected_video],
    isAdditionalMenuOpened: state.videolists.additional_menu.open,
    isAdditionalSelected: state.videolists.additional_menu.payload?.songId ? state.videolists.additional_menu.payload?.songId === String(props.id) : true,
    leftMarker:  state.videolists_all.clipSummery.clips.indexOf(props.id) !== -1,


})

export default connect(stateToProps, null)(SongsContainer)